import { MinusCircleIcon } from '@heroicons/react/solid';
import { format } from 'date-fns';
import { useState, useEffect } from 'react';
import { Input, Label } from '../Field';

function GapsTab({ gaps: propGaps, t }) {
    const [gaps, setGaps] = useState(propGaps || []);

    const updateGap = (index, field, value) => {
        setGaps((prev) => {
            const next = JSON.parse(JSON.stringify(prev));
            next[index][field] = value;
            return next;
        });
    };

    const removeGap = (index) => {
        setGaps((prev) => {
            const next = JSON.parse(JSON.stringify(prev));
            next.splice(index, 1);
            return next;
        });
    };

    useEffect(() => {
        setGaps(
            (propGaps || []).map(({ start, end }) => ({
                start: format(new Date(start), "yyyy-MM-dd'T'HH:mm"),
                end: format(new Date(end), "yyyy-MM-dd'T'HH:mm"),
            }))
        );
    }, [propGaps]);

    return (
        <div className="space-y-2">
            {gaps.length == 0 && <input type="hidden" name="gaps[]" />}
            {gaps.map(({ start, end }, index) => (
                <div key={index} className="flex gap-8">
                    <div className="flex items-center gap-2">
                        <Label>{t('start')}</Label>
                        <input type="hidden" name={`gaps[${index}][start]`} defaultValue={start ? new Date(start).toISOString() : ''} />
                        <Input
                            type="datetime-local"
                            className="w-48 py-1 text-xs"
                            value={start}
                            onChange={(e) => {
                                updateGap(index, 'start', e.target.value);
                            }}
                            required
                        />
                    </div>
                    <div className="flex items-center gap-2">
                        <Label>{t('end')}</Label>
                        <input type="hidden" name={`gaps[${index}][end]`} defaultValue={end ? new Date(end).toISOString() : ''} />
                        <Input
                            type="datetime-local"
                            className="w-48 py-1 text-xs"
                            value={end}
                            onChange={(e) => {
                                updateGap(index, 'end', e.target.value);
                            }}
                            required
                        />
                    </div>
                    <button
                        onClick={() => {
                            removeGap(index);
                        }}
                        type="button"
                        className="flex-none ml-2 text-gray-400 hover:text-gray-700"
                    >
                        <MinusCircleIcon className="w-5 h-5" />
                    </button>
                </div>
            ))}

            <button
                onClick={() => {
                    setGaps((prev) => [...JSON.parse(JSON.stringify(prev)), { start: '', end: '' }]);
                }}
                type="button"
                className="text-xs text-gray-500 hover:text-gray-800"
            >
                + {t('add-gap')}
            </button>
        </div>
    );
}

export default GapsTab;
